export const IMG_CON_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

//config driven UI
export const restaurantList = [
  {
    type: "Restaurant",
    data: {
      type: "F",
      id: "17518",
      name: "KFC",
      uuid: "8aa71b67-a19a-4ee1-ba37-5fd62e29be3e",
      city: "4",
      area: "Kalkaji",
      totalRatingsString: "10000+ ratings",
      cloudinaryImageId: "56c9ab92bd79745fd152a30fa2525426",
      cuisines: ["Burgers", "Biryani", "American", "Snacks", "Fast Food"],
      tags: [],
      costForTwo: 40000,
      costForTwoString: "₹400 FOR TWO",
      deliveryTime: 34,
      minDeliveryTime: 34,
      maxDeliveryTime: 34,
      slaString: "34 MINS",
      lastMileTravel: 6.699999809265137,
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "651445",
      name: "Yogi Chinese Adda",
      uuid: "c285ed86-d454-489a-886e-7ca0be52ddff",
      city: "10459",
      area: "Golf Course Road",
      totalRatingsString: "Too Few Ratings",
      cloudinaryImageId: "b780538b71f5cd5621900a2f9cf384b1",
      cuisines: ["Chinese", "North Indian", "Fast Food", "Snacks"],
      tags: [],
      costForTwo: 19900,
      costForTwoString: "₹199 FOR TWO",
      deliveryTime: 37,
      minDeliveryTime: 37,
      maxDeliveryTime: 37,
      slaString: "37 MINS",
      lastMileTravel: 4.5,
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "365826",
      name: "NIC Ice Creams",
      uuid: "9bef0d26-2a9f-4f21-9343-6f15c6e47e0a",
      city: "4",
      area: "Jasola",
      totalRatingsString: "1000+ ratings",
      cloudinaryImageId: "91d6dda411b108965541c16ac1cfe2bc",
      cuisines: ["Ice Cream", "Desserts"],
      tags: [],
      costForTwo: 12000,
      costForTwoString: "₹120 FOR TWO",
      deliveryTime: 17,
      minDeliveryTime: 17,
      maxDeliveryTime: 17,
      slaString: "17 MINS",
      lastMileTravel: 0.6000000238418579,
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "394288",
      name: "BALLIMARAN NAHARI RESTAURANT",
      uuid: "2eaf4e4a-2edc-4619-bfe1-cad390f77983",
      city: "4",
      area: "Jasola",
      totalRatingsString: "500+ ratings",
      cloudinaryImageId: "lniomcs0ke4fim9mfo18",
      cuisines: ["Indian", "Biryani"],
      tags: [],
      costForTwo: 17000,
      costForTwoString: "₹170 FOR TWO",
      deliveryTime: 18,
      minDeliveryTime: 18,
      maxDeliveryTime: 18,
      slaString: "18 MINS",
      lastMileTravel: 0.5,
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "644328",
      name: "Giani's",
      uuid: "4c8cc2b0-12dc-48d6-899a-4c75781d2dd6",
      city: "4",
      area: "Jasola",
      totalRatingsString: "Too Few Ratings",
      cloudinaryImageId: "8c6cdf744fd40f7d502c3fb801168034",
      cuisines: ["Ice Cream", "Beverages", "Desserts"],
      tags: [],
      costForTwo: 25000,
      costForTwoString: "₹250 FOR TWO",
      deliveryTime: 20,
      minDeliveryTime: 20,
      maxDeliveryTime: 20,
      slaString: "20 MINS",
      lastMileTravel: 0.8999999761581421,
    },
  },
  {
    type: "restaurant",
    data: {
      type: "F",
      id: "36913",
      name: "Nazeer Foods",
      uuid: "4db63494-6aa5-43c9-9b47-80e50b2d52b1",
      city: "4",
      area: "Jasola",
      totalRatingsString: "10000+ ratings",
      cloudinaryImageId: "dflnxjij5k0h67jioqxx",
      cuisines: ["North Indian", "Biryani", "Mughlai", "Snacks"],
      tags: [],
      costForTwo: 40000,
      costForTwoString: "₹400 FOR TWO",
      deliveryTime: 21,
      minDeliveryTime: 21,
      maxDeliveryTime: 21,
      slaString: "21 MINS",
      lastMileTravel: 0.8999999761581421,
    },
  },
];
